import React from 'react';
import { pidgeon } from './pidgeon.js';
import { ptero } from './pterodactyl';
import { turkey } from './turkey.js';
import { penguin } from './penguin.js';
import './birdimages.css';
export function pteroIMG() {
    return (React.createElement("div", { className: "ptero svgcontainer", dangerouslySetInnerHTML: { __html: ptero } }));
}
export function pidgeionIMG() {
    return (React.createElement("div", { className: "pidgeon svgcontainer", dangerouslySetInnerHTML: { __html: pidgeon } }));
}
export function turkeyIMG() {
    return (React.createElement("div", { className: "turkey svgcontainer", dangerouslySetInnerHTML: { __html: turkey } }));
}
export function penguinIMG() {
    return (React.createElement("div", { className: "penguin svgcontainer", dangerouslySetInnerHTML: { __html: penguin } }));
}
